// NPM
import { graphql } from "gatsby"
import _ from "lodash"
import * as React from "react"

// Components
import Careers from "src/components/pages/Careers/Careers"
import Layout from "src/layouts/fr"

const GenericProductPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `careersPage.sections`, [])
  const jobPostings = _.get(data, `jobPostings.nodes`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.careersPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <Careers sections={sections} jobPostings={jobPostings} />
    </Layout>
  )
}

export default GenericProductPageFr

export const query = graphql`
  query CareersPageFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    careersPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    jobPostings: allStrapiJobPosting(
      filter: { locale: { eq: "fr" }, title: { ne: "__test" } }
    ) {
      nodes {
        ...jobPosting
      }
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
